import React, { useState } from "react";
import Editor from "@monaco-editor/react";
import { Wand2 } from "lucide-react";
import { toast } from "react-toastify";
import { formatCode, isFormattable } from "../lib/formatCode";

const CodeEditorWindow = ({ onChange, language, code, theme }) => {
  const [formatting, setFormatting] = useState(false);
  const formattable = isFormattable(language);

  const handleEditorChange = (value) => {
    onChange("code", value ?? "");
  };

  const handleFormat = async () => {
    if (!formattable || formatting) return;
    setFormatting(true);
    try {
      const formatted = await formatCode(code, language);
      onChange("code", formatted);
    } catch (err) {
      toast.error("Could not format code — check for syntax errors.");
    } finally {
      setFormatting(false);
    }
  };

  return (
    <div className="flex w-full h-full flex-col overflow-hidden rounded-sm border border-vscode-border">
      <div className="flex items-center justify-end border-b border-vscode-border bg-vscode-panel px-2 py-1">
        <button
          onClick={handleFormat}
          disabled={!formattable || formatting}
          title={
            formattable
              ? "Format Document"
              : "Formatting isn't available for this language"
          }
          className="flex items-center gap-1.5 rounded-sm px-2 py-1 text-xs text-vscode-textMuted hover:bg-vscode-listHover hover:text-vscode-textBright disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent"
        >
          <Wand2 size={13} strokeWidth={1.5} />
          {formatting ? "Formatting…" : "Format"}
        </button>
      </div>
      <Editor
        height="70vh"
        width={`100%`}
        language={language || "javascript"}
        value={code}
        theme={theme}
        loading="Loading..."
        onChange={handleEditorChange}
        options={{
          fontFamily: "'Fira Code', Consolas, 'Courier New', monospace",
          fontLigatures: true,
          minimap: { enabled: true },
        }}
      />
    </div>
  );
};
export default CodeEditorWindow;
